import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { loginAPI } from "@/apis/loginAPI";
import { getUserMessageAPI } from "@/apis/userAPI";

export const useUserStore = defineStore('user', () => {
  // 用户身份
  const token = ref('');
  const userId = ref(5);

  // 当前用户档案（含 fields: 厂区列表，每项含 level）
  const userInfo = ref(null);
  const userInfoLoaded = ref(false);

  // 登录：保存 token / userId，并主动拉一次用户信息
  const getToken = async (data) => {
    const res = await loginAPI(data);
    token.value = res.data.jwt;
    userId.value = res.data.userId;
    await fetchUserInfo();
  };

  // 拉取 /api/user/{id}，结果存入 userInfo
  const fetchUserInfo = async () => {
    if (!userId.value) return;
    try {
      const { data } = await getUserMessageAPI(userId.value);
      userInfo.value = data;
    } catch (e) {
      userInfo.value = null;
    } finally {
      userInfoLoaded.value = true;
    }
  };

  // 判定：返回的第一个厂区 level === 2（超级管理员）才允许看商城
  const canSeeMall = computed(() => {
    const fields = userInfo.value?.fields;
    return Array.isArray(fields) && fields.length > 0 && fields[0]?.level === 2;
  });

  // 退出：清空所有用户态
  const clearToken = () => {
    token.value = '';
    userInfo.value = null;
    userInfoLoaded.value = false;
  };

  // ===== 临时开关 =====
  // false：关闭前端对商城管理的权限控制（用于测试后端权限控制）
  // true ：恢复前端权限控制（测试完后请改回 true）
  const mallGuardEnabled = ref(true);

  return {
    token,
    userId,
    userInfo,
    userInfoLoaded,
    canSeeMall,
    mallGuardEnabled,
    getToken,
    fetchUserInfo,
    clearToken,
  };
}, {
  // 仅持久化身份字段，userInfo 每次重新拉取，避免陈旧
  persist: { paths: ['token', 'userId'] },
});